<!--
 * @Date: 2020-08-05 20:04:51
 * @LastEditors: Mosuzi
 * @LastEditTime: 2020-08-05 20:48:58
 * @Description: In User Settings Edit
 * @Author: Mosuzi
-->
<template>
  <div class="about">
    <div class="logo-container">
      <img src="../../../assets/logo.png" />
      <span>{{ $t('profile.about.version') }}{{ version }}</span>
    </div>
    <line-text
      :content="$t('profile.about.newFeatures')"
      link
      class="fix-padding-left content-link"
      @click="pushUpdateLog"></line-text>
    <line-text
      :content="$t('profile.about.serviceProtocol')"
      link
      class="fix-padding-left content-link"
      @click="showProtocol"></line-text>
    <div class="copyright">
      {{ $t('profile.about.copyright') }}
    </div>
  </div>
</template>

<script>
import LineText from '@/components/line-text/line-text.vue'
export default {
  components: {
    LineText
  },
  data() {
    return {
      version: '1.0.0'
    }
  },
  methods: {
    showProtocol() {
      this.$router.push({
        name: 'service-protocol'
      })
    },
    pushUpdateLog() {
      window.open('https://definesys.cn/support/product-center/update-log/')
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  height: 100%;
  width: 100%;
  background: $--app-body-bgColor;
  position: relative;
  .logo-container {
    height: 13rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 14.286rem;
      height: 3.714rem;
    }
    span {
      margin-top: 1.143rem;
      color: $--app-content-color;
    }
  }
  .content-link {
    background: $--app-light-color;
    .line-content {
      color: $--app-content-color;
    }
    .link-edit {
      padding-right: .7857rem;
    }
  }
  .copyright {
    position: absolute;
    bottom: 3.214rem;
    width: 100%;
    text-align: center;
    color: $--app-notice-color;
  }
}
</style>
